import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import { Flex, Box, Heading } from "rebass/styled-components"

const PertnershipBlock = () => {
  const data = useStaticQuery(graphql`
    {
      questionFileName: file(relativePath: { eq: "kv_vopros.png" }) {
        childImageSharp {
          gatsbyImageData(width: 400, layout: CONSTRAINED)
        }
      }
      fazendaFileName: file(relativePath: { eq: "fazenda.png" }) {
        childImageSharp {
          gatsbyImageData(width: 400, layout: CONSTRAINED)
        }
      }
    }
  `)

  return (
    <Box py={[3, 4, 5]}>
      <Heading textAlign="center" mb={[3, 4]}>
        Сотрудничество
      </Heading>
      <Flex justifyContent="space-around" flexDirection={["column", "row"]}>
        {data?.questionFileName && (
          <Box width={1} maxWidth={400} mb={[3, 0]}>
            <GatsbyImage
              image={data?.questionFileName?.childImageSharp?.gatsbyImageData}
            />
          </Box>
        )}
        {data?.fazendaFileName && (
          <Box width={1} maxWidth={400}>
            <GatsbyImage
              image={data?.fazendaFileName?.childImageSharp?.gatsbyImageData}
            />
          </Box>
        )}
      </Flex>
    </Box>
  )
}

export default PertnershipBlock
